import { Component, OnInit } from '@angular/core';
import { NavigationService } from '@fgb/portal-component-library/src/lib/shared/services';

@Component({
  selector: 'fgb-worksheet-gallery',
  templateUrl: './worksheet-gallery.component.html',
  styleUrl: './worksheet-gallery.component.scss',
})
export class WorksheetGalleryComponent implements OnInit {
  constructor(private navigationService: NavigationService) {}

  ngOnInit(): void {
    this.navigationService.hideMobileNav();
  }

  ngOnDestroy(): void {
    this.navigationService.showMobileNav();
  }
}
